<template>
  <div class="demographic">
    <div class="demographic__header">
      <div class="demographic__header__left">
        <h1 class="large-font">{{campaignDetail.get_campaign_name}} </h1>
        <span class="small-font subtitle"> Campaign Period : {{displayPeriod(campaignDetail.get_start, campaignDetail.get_end)}}</span>
      </div>
    </div>
    <div class="demographic__report">
      <div class="demographic__report__sidemenu">
        <h2 class="large-font title">Demographic</h2>
        <ul>
          <router-link tag="li" :to="{name: 'gender'}" class="subhead">Gender</router-link>
          <router-link tag="li" :to="{name: 'age'}" class="subhead">Age</router-link>
          <router-link tag="li" :to="{name: 'interest'}" class="subhead">Interest</router-link>
        </ul>
        <h2 class="large-font title">Mobile</h2>
        <ul>
          <router-link tag="li" :to="{name: 'operatingsystem'}" class="subhead">Operating System</router-link>
        </ul>
      </div>
      <div class="demographic__report__content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'

import { formatShortDate, dateFormat } from '@/lib/util'
import moment from 'moment'

export default {
  name: 'adx-campaignreport-demographic',
  components: {

  },
  props: {

  },
  data() {
    return {
      data: {},
      campaignDetail: []
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      const { status, data } = await api.get(apiV2.measurementcampaignReportDetail(this.$route.params.campaign_id), { needToken: true })
      if(status == 200) {
        this.campaignDetail = await data
      }
    },
    displayPeriod(start, end) {
      let startDate = moment(start, 'YYYY-MM-DD')
      let endDate = moment(end, 'YYYY-MM-DD')
      if (startDate.year() == endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      } else if (startDate.year() < endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>